import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL || "";
const API_BASE = `${BASE_URL}/api`;

const apiClient = axios.create({
  baseURL: API_BASE,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API error", error);
    return Promise.reject(error);
  },
);

export const getVisaCountries = async () => {
  const res = await apiClient.get("/visa-countries");
  return res.data.countries;
};

export const createRequest = async (payload) => {
  const res = await apiClient.post("/requests", payload);
  return res.data;
};

export const getRequests = async (params = {}) => {
  // Staff-only: leads contain personal data.
  let token = null;
  try { token = localStorage.getItem("venka_token"); } catch (e) { token = null; }
  const res = await apiClient.get("/requests", { params, headers: token ? { Authorization: `Bearer ${token}` } : {} });
  return res.data;
};

// ----- Public application / onboarding -----
export const getPublicProcessTypes = async () => {
  const res = await apiClient.get("/public/process-types");
  return res.data;
};

export const submitPublicApplication = async (payload) => {
  const res = await apiClient.post("/public/apply", payload);
  return res.data;
};

export const validateInvite = async (token) => {
  const res = await apiClient.get(`/public/invite/${token}`);
  return res.data;
};

export const activateAccount = async (token, password) => {
  const res = await apiClient.post("/public/activate", { token, password });
  return res.data;
};

export const consumeMagicLink = async (token) => {
  const res = await apiClient.get(`/public/magic/${token}`);
  return res.data;
};

// ----- GDPR self-service (intake submissions) -----
export const requestMyData = async (reference, email) => {
  const res = await apiClient.post("/applications/data-request", { reference, email });
  return res.data;
};

export const requestMyDeletion = async (reference, email) => {
  const res = await apiClient.post("/applications/deletion-request", { reference, email });
  return res.data;
};

export default apiClient;
